/* eslint-disable camelcase */

import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button';
import ReactPlayer from 'react-player';
import staticPath from 'util/misc/static-assets-path';
import t from 'translations';
import normaliseTrailingSlash from 'util/misc/normalise-trailing-slash';

const renderLink = link => {
    const { to, style, label } = link;
    return (
        <div className="cms-video-column--actions">
            <div className="cms-video-column--action cms-video-column--action__link">
                <Button tag={'a'} className="cms-video-column--link" facet={['x-large', style]}
                    to={normaliseTrailingSlash(to)}>
                    {label}
                </Button>
            </div>
        </div>
    );
};

const renderAppStoreButtons = app_links => {
    const { google_play_link, app_store_link, text } = app_links;
    return (
        <div className="cms-video-column--app-store">
            <div className="cms-video-column--app-store-text">{text}</div>
            <div className="cms-video-column--app-store-links">
                <a
                    aria-label={t('accessibility.label.buy_on_googleplay')}
                    className="cms-video-column--app-store-link u-reset" href={google_play_link} target="_blank">
                    <img
                        className="cms-video-column--app-store-img"
                        src={staticPath('img/logos/im-googleplay-badge.svg')}
                    />
                </a>
                <a
                    aria-label={t('accessibility.label.buy_on_appstore')}
                    className="cms-video-column--app-store-link u-reset" href={app_store_link} target="_blank">
                    <img
                        className="cms-video-column--app-store-img"
                        src={staticPath('img/logos/im-appstore-badge.svg')}
                    />
                </a>
            </div>
        </div>
    );
};

export default function VideoColumn({ title, link, sub_link, app_links, text, video }) {
    return (
        <div className="cms-video-column">
            <h2 className="cms-video-column--title u-reset">{title}</h2>
            {text && <div className="cms-video-column--text" dangerouslySetInnerHTML={{ __html: text }}/> }
            <div className="cms-video-column--video-wrapper">
                <div className="cms-video-column--video-player">
                    <ReactPlayer config={{
                        youtube: {
                            playerVars: {
                                autoplay: 0,
                                iv_load_policy: 1,
                                playsinline: 0,
                                modestbranding: 0,
                                controls: 1,
                            },
                        },
                    }}
                    url={video.url}
                    width="100%"
                    height="100%"/>
                </div>
            </div>
            {link && renderLink(link)}
            {app_links && renderAppStoreButtons(app_links)}
            {sub_link && renderLink(sub_link)}
        </div>
    );
}

VideoColumn.propTypes = {
    link: PropTypes.shape({
        to: PropTypes.string.isRequired,
        style: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    }),
    sub_link: PropTypes.shape({
        to: PropTypes.string.isRequired,
        style: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    }),
    app_links: PropTypes.shape({
        app_store_link: PropTypes.string.isRequired,
        play_store_link: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
    }),
    title: PropTypes.string.isRequired,
    text: PropTypes.string,
    video: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/video-column/index.js